import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useForm } from "react-hook-form";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

export default function Index() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [formopen, setFormopen] = React.useState(false);
  const [submitDisabled, setsubmitDisabled] = useState(false);

  const [open, setOpen] = React.useState(false);
  const [otoast, setotoast] = React.useState(false);
  const [portfolioid, setportfolioid] = React.useState(0);
  const [folioName, setfolioName] = React.useState("");

  const handleClose = () => {
    setFormopen(false);
  };
  const handlerClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (e) => {
    setOpen(true);
    setportfolioid(e.target.getAttribute("data-value"));
  };

  const thandleClose = (event, reason) => {
    setotoast(false);
  };

  const handleAgree = (res) => {
    setLoading(true);
    RestService.deletePortfolio(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.status === 1) {
          setglobaldata(response.data.portfolio);
          setotoast(true);
        }
        setOpen(false);
      },
      mobile,
      web_token,
      portfolioid
    );

    //setOpen(false);
  };

  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getPortfolioList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.portfolio);
      },
      mobile,
      web_token
    );
    setLoading(false);
  }, [mobile, web_token]);

  const handleFormOpen = (e) => {
    let id = e.target.getAttribute("data-value")
      ? e.target.getAttribute("data-value")
      : 0;
    let name = e.target.getAttribute("data-pname")
      ? e.target.getAttribute("data-pname")
      : "";
    setportfolioid(id);
    setfolioName(name);
    setFormopen(true);
  };

  // form validation rules
  const validationSchema = Yup.object().shape({
    portfolio_name: Yup.string().required("Portfolio Name is required"),
  });

  // functions to build form returned by useForm() hook

  const { register, handleSubmit, reset, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });

  function onSubmit(fdata) {
    // display form data on success
    //alert('SUCCESS!! :-)\n\n' + JSON.stringify(data, null));
    setsubmitDisabled(true);
    const data = JSON.stringify(fdata, null);
    RestService.updatePortfolioData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setsubmitDisabled(false);
        if (response.data.status === 1) {
          setglobaldata(response.data.portfolio);
          setFormopen(false);
          //history.push('/watchlist');
        }

        //return <Redirect to={"watchlist"} />;
      },
      mobile,
      web_token,
      data
    ); /* */
    setsubmitDisabled(false);
  }

  return (
    <>
      {loading ? <Loader /> : ""}
      <Dialog
        open={formopen}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)} onReset={reset} method="post">
          <DialogTitle id="form-dialog-title">My Portfolio</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter your protfolio Name here..
            </DialogContentText>

            <input
              autoFocus
              margin="dense"
              id="name"
              name="portfolio_name"
              label="Portfolio Name Here"
              defaultValue={folioName}
              type="text"
              ref={register}
              className={`form-control ${
                errors.portfolio_name ? "is-invalid" : ""
              }`}
            />
            <div className="invalid-feedback">
              {errors.portfolio_name?.message}
            </div>
            <input
              type="hidden"
              ref={register}
              name="portfolio_id"
              defaultValue={portfolioid}
            />
            <div></div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <input
              type="submit"
              name="submit"
              disabled={submitDisabled}
              className="btn btn-success"
              defaultValue="SUBMIT &raquo;"
            />
            {submitDisabled ? <CircularProgress color="secondary" /> : ""}
          </DialogActions>
        </form>
      </Dialog>

      <GlobalHelmet {...Common?.portfolio} />

      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <button className="btn btn-success" onClick={handleFormOpen}>
                  <i className="fa fa-edit"></i> Add Portfolio
                </button>
              </div>
              <Breadcrumbs page="My Portfolio" addon="addon" />

              <div className={classes.root}>
                <Grid container spacing={3}>
                  {globaldata
                    ? globaldata.map((items) => (
                        <Grid
                          item
                          key={items.id}
                          className="customwatch"
                          xs={6}
                          sm={4}
                          md={4}
                          lg={2}
                        >
                          <Link to={"/portfolio-stock/" + items.id}>
                            <Paper
                              className={"custom-grid-style " + classes.paper}
                            >
                              {items.name}
                            </Paper>
                          </Link>

                          <i
                            onClick={handleFormOpen}
                            className="fa fa-edit editwatchList"
                            data-value={items.id}
                            data-pname={items.name}
                          ></i>

                          <i
                            onClick={handleClickOpen}
                            data-value={items.id}
                            className="fa fa-trash trashwatchList"
                          ></i>
                        </Grid>
                      ))
                    : ""}
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={otoast}
        onClose={handleClose}
        message="Portfolio has been deleted successfully"
        key="top center"
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={thandleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Remove Portfolio"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure want to remove this Portfolio?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlerClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleAgree} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
